import React from "react";
import { Alert} from "@material-ui/lab";
import {Typography } from '@material-ui/core';
import { FormattedMessage } from "react-intl";

const ErrorMessage = (props) => {
  return (
    <>
      <Alert severity="error">
        <Typography variant="subtitle1">
          {props.error === "application_not_found" ?
          <FormattedMessage defaultMessage= "Application not found. Please contact your administrator." /> 
          : props.error === "internal_server_error" ?
          <FormattedMessage defaultMessage= "An error has occurred communicating with the server. Please try again." />
          : props.error === "Forbidden" ?
          <FormattedMessage defaultMessage= "you do not have permission to perform this operation. Please contact your administrator." /> 
          : props.error === "error_removing_application" ?
          <FormattedMessage defaultMessage= "An error occurred, and we could not disconnect the application. Try again later." />
          :
          <FormattedMessage defaultMessage= "Error occured. Please try again later." />}
        </Typography>
      </Alert>
    </>
  );
};

export default ErrorMessage;
